import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createDashboardT, getDashboardPlanLabel } from '../i18n/dashboard';
import QuickCreditTopUp from './QuickCreditTopUp';

function UserAvatar({ user, className, placeholderClassName, size = 36 }) {
  const [failed, setFailed] = useState(false);
  const picture = user?.picture?.trim();

  if (!picture || failed) {
    return (
      <div
        className={placeholderClassName}
        style={placeholderClassName ? undefined : { width: `${size}px`, height: `${size}px`, borderRadius: '999px', display: 'grid', placeItems: 'center', background: 'linear-gradient(135deg, #4F46E5, #6366F1)', color: '#fff', fontSize: '13px', fontWeight: 900 }}
      >
        {user?.name?.[0] || '?'}
      </div>
    );
  }

  return (
    <img
      className={className}
      src={picture}
      alt=""
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      style={className ? undefined : { width: `${size}px`, height: `${size}px`, borderRadius: '999px', objectFit: 'cover' }}
    />
  );
}

const styles = `
.fet-profile-menu{
  position:absolute;
  top:52px;
  right:0;
  min-width:280px;
  background:
    radial-gradient(circle at top right, rgba(79,70,229,.10), transparent 34%),
    linear-gradient(180deg, rgba(255,255,255,.96), rgba(248,250,252,.94));
  backdrop-filter:blur(16px);
  border-radius:20px;
  box-shadow:0 24px 54px rgba(15,23,42,.18);
  border:1px solid rgba(226,232,240,.85);
  z-index:200;
  overflow:hidden;
  font-family:"Inter","Outfit","SF Pro Display",ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  transform-origin:top right;
  padding:10px;
  animation:fetProfileMenuFade .2s ease;
}
.fet-profile-section{
  padding:12px;
}
.fet-profile-identity{
  display:flex;
  align-items:center;
  gap:12px;
}
.fet-profile-avatar,
.fet-profile-avatar-placeholder{
  width:44px;
  height:44px;
  border-radius:50%;
  flex:0 0 auto;
  border:2px solid rgba(255,255,255,.72);
  box-shadow:0 0 0 4px rgba(79,70,229,.08);
}
.fet-profile-avatar{
  object-fit:cover;
}
.fet-profile-avatar-placeholder{
  display:flex;
  align-items:center;
  justify-content:center;
  background:linear-gradient(135deg, rgba(79,70,229,.95), rgba(99,102,241,.9));
  color:#fff;
  font-size:14px;
  font-weight:900;
}
.fet-profile-name{
  font-size:15px;
  font-weight:900;
  color:#0f172a;
}
.fet-profile-email{
  font-size:12px;
  color:#64748b;
  margin-top:4px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.fet-profile-status{
  margin-top:10px;
  padding:14px;
  border-radius:16px;
  background:
    linear-gradient(180deg, rgba(15,23,42,.03), rgba(255,255,255,.7)),
    linear-gradient(135deg, rgba(79,70,229,.08), rgba(99,102,241,.06));
  border:1px solid rgba(226,232,240,.9);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.7);
}
.fet-credit-pill{
  display:flex;
  align-items:center;
  gap:12px;
  padding:8px 10px 8px 14px;
  border-radius:18px;
  border:1px solid rgba(79,70,229,.14);
  background:
    radial-gradient(circle at top right, rgba(99,102,241,.12), transparent 42%),
    linear-gradient(180deg, rgba(255,255,255,.98), rgba(238,242,255,.96));
  box-shadow:0 14px 28px rgba(79,70,229,.08);
  color:#0f172a;
  white-space:nowrap;
}
.fet-credit-summary{
  display:grid;
  gap:2px;
}
.fet-credit-label{
  font-size:10px;
  color:#4338ca;
  font-weight:800;
  letter-spacing:.08em;
  text-transform:uppercase;
}
.fet-credit-pill strong{
  font-size:18px;
  font-weight:900;
  line-height:1;
}
.fet-credit-pill span{
  font-size:12px;
  color:#475569;
  font-weight:700;
}
.fet-profile-status-label{
  font-size:10px;
  letter-spacing:.14em;
  text-transform:uppercase;
  color:#94a3b8;
  font-weight:800;
}
.fet-profile-badge{
  display:inline-flex;
  margin-top:10px;
  border-radius:999px;
  padding:6px 10px;
  font-size:11px;
  font-weight:800;
  background:rgba(79,70,229,.10);
  border:1px solid rgba(79,70,229,.18);
  color:#4338ca;
}
.fet-profile-actions{
  display:grid;
  gap:6px;
  padding:4px 0 0;
}
.fet-profile-item{
  width:100%;
  padding:12px 14px;
  text-align:left;
  background:none;
  border:none;
  cursor:pointer;
  font-family:"Inter","Outfit","SF Pro Display",ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  font-size:14px;
  color:#0f172a;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  border-radius:14px;
  transition:background .18s ease, transform .18s ease, color .18s ease, box-shadow .18s ease;
}
.fet-profile-item:hover{
  background:#f8fafc;
  transform:translateX(-2px);
  box-shadow:0 10px 18px rgba(15,23,42,.06);
}
.fet-profile-item-main{
  display:flex;
  align-items:center;
  gap:10px;
}
.fet-profile-item-icon{
  width:32px;
  height:32px;
  border-radius:10px;
  display:flex;
  align-items:center;
  justify-content:center;
  background:rgba(15,23,42,.05);
  color:#475569;
}
.fet-profile-item:hover .fet-profile-item-icon{
  background:rgba(79,70,229,.10);
  color:#4338ca;
}
.fet-profile-item-arrow{
  color:#94a3b8;
  font-size:12px;
}
.fet-profile-item.danger{
  color:#dc2626;
}
.fet-profile-item.danger .fet-profile-item-icon{
  background:rgba(220,38,38,.08);
  color:#dc2626;
}
.fet-profile-item.danger:hover{
  background:rgba(254,242,242,.9);
}
@keyframes fetProfileMenuFade{
  from{opacity:0;transform:translateY(-6px) scale(.98)}
  to{opacity:1;transform:translateY(0) scale(1)}
}
`;

function formatRemaining(ms) {
  if (ms <= 0) return null;
  const totalMinutes = Math.floor(ms / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) return `${days}d ${hours}h left`;
  if (hours > 0) return `${hours}h ${minutes}m left`;
  return `${minutes}m left`;
}

export default function FETProfileMenu({ user, onLogout, showBalance = false }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const t = createDashboardT('ar');
  // Tick every minute so the promo-trial countdown stays current without
  // hammering re-renders. We only display d/h/m granularity anyway.
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, []);
  // Only show the trial chip when the user is genuinely on a promo:
  //   - active  → effective_plan === 'promo' AND expiry is in the future
  //   - expired → raw plan was 'promo' but effective_plan flipped to 'free'
  // A free-tier user with a stale plan_expires_at value sees nothing.
  const rawPlan = String(user?.plan || 'free').toLowerCase();
  const effectivePlan = String(user?.effective_plan || rawPlan).toLowerCase();
  const expiresAt = user?.plan_expires_at ? new Date(user.plan_expires_at).getTime() : null;
  const promoActive = effectivePlan === 'promo' && expiresAt !== null && expiresAt - now > 0;
  const promoJustExpired = rawPlan === 'promo' && effectivePlan !== 'promo';
  const remainingLabel = promoActive ? formatRemaining(expiresAt - now) : null;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!user) return null;

  return (
    <div ref={menuRef} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <style>{styles}</style>
      {showBalance && (
        <>
          <div className="fet-credit-pill" title="Available AI credits" style={{ marginRight: 10 }}>
            <div className="fet-credit-summary">
              <div className="fet-credit-label">AI Wallet</div>
              <strong>{user.ai_credits ?? 0}</strong>
            </div>
            <span>AI credits left</span>
            <QuickCreditTopUp returnTo={`${window.location.pathname}${window.location.search}`} />
          </div>
        </>
      )}
      <button
        onClick={() => setMenuOpen((open) => !open)}
        style={{
          border: 'none',
          background: 'transparent',
          padding: 0,
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <UserAvatar user={user} size={36} />
      </button>
      {menuOpen && (
        <div className="fet-profile-menu">
          <div className="fet-profile-section">
            <div className="fet-profile-identity">
              <UserAvatar user={user} className="fet-profile-avatar" placeholderClassName="fet-profile-avatar-placeholder" />
              <div style={{ minWidth: 0 }}>
                <div className="fet-profile-name">{user.name}</div>
                <div className="fet-profile-email">{user.email}</div>
              </div>
            </div>
            <div className="fet-profile-status">
              <div className="fet-profile-status-label">FET Account</div>
              <div className="fet-profile-badge">{getDashboardPlanLabel(user.plan, t)}</div>
              {remainingLabel && (
                <div style={{
                  marginTop: 6, fontSize: 11, fontWeight: 800,
                  color: '#B45309', letterSpacing: 0.2,
                }}>
                  Trial · {remainingLabel}
                </div>
              )}
              {promoJustExpired && (
                <div style={{
                  marginTop: 6, fontSize: 11, fontWeight: 800,
                  color: '#B91C1C', letterSpacing: 0.2,
                }}>
                  Trial expired
                </div>
              )}
              <div style={{ marginTop: 10, fontSize: 12, color: '#475569', fontWeight: 700 }}>
                {t('credits', { count: user.ai_credits ?? 0 })}
              </div>
            </div>
          </div>
          <div className="fet-profile-section">
            <div className="fet-profile-actions">
              <button onClick={() => { navigate(`/pricing?return_to=${encodeURIComponent(`${window.location.pathname}${window.location.search}`)}`); setMenuOpen(false); }} className="fet-profile-item">
                <div className="fet-profile-item-main">
                  <span className="fet-profile-item-icon">◫</span>
                  <span>Billing & Plan</span>
                </div>
                <span className="fet-profile-item-arrow">›</span>
              </button>
              <button onClick={() => { navigate('/reports'); setMenuOpen(false); }} className="fet-profile-item">
                <div className="fet-profile-item-main">
                  <span className="fet-profile-item-icon">▣</span>
                  <span>Recent Reports</span>
                </div>
                <span className="fet-profile-item-arrow">›</span>
              </button>
              <button onClick={() => { navigate('/credit-history'); setMenuOpen(false); }} className="fet-profile-item">
                <div className="fet-profile-item-main">
                  <span className="fet-profile-item-icon">◎</span>
                  <span>Credit History</span>
                </div>
                <span className="fet-profile-item-arrow">›</span>
              </button>
              {user?.is_admin && (
                <button onClick={() => { navigate('/admin'); setMenuOpen(false); }} className="fet-profile-item">
                  <div className="fet-profile-item-main">
                    <span className="fet-profile-item-icon">⚙</span>
                    <span>Admin Panel</span>
                  </div>
                  <span className="fet-profile-item-arrow">›</span>
                </button>
              )}
              <button onClick={() => { onLogout?.(); setMenuOpen(false); }} className="fet-profile-item danger">
                <div className="fet-profile-item-main">
                  <span className="fet-profile-item-icon">↩</span>
                  <span>Logout</span>
                </div>
                <span className="fet-profile-item-arrow">›</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
